/* eslint-disable @typescript-eslint/no-explicit-any */
import { keysOf } from '@waitroom/utils';
import i18next from 'i18next';
import { useMemo } from 'react';
import { SupportedLanguages } from '../../locales/res/translation';

export type UseAddTranslationsProps =
  | Record<string, Dict<any>>
  | Record<SupportedLanguages, Dict<any>>;

export const useAddTranslations = (
  trans: UseAddTranslationsProps,
  namespace = 'translation',
): void => {
  useMemo(() => {
    const keys = keysOf(trans);
    for (const key of keys) {
      const lang = key.length > 2 ? (key.substring(25, 27) as SupportedLanguages) : key;
      i18next.addResourceBundle(lang, namespace, trans[key], true);
    }
  }, [namespace, trans]);
};
